export default "__VITE_ASSET__Dnd7N8Bp__"